import { memo } from 'react';
import Fade from '@mui/material/Fade';

export default memo(Fade);
